import React, { useCallback } from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import { Input, Icon } from 'antd';
import debounce from 'lodash/debounce';
import styles from './styles.less';

const Search = ({ onSearchChange }) => {
  const debouncedOnSearchChange = useCallback(debounce(onSearchChange, 300), [
    onSearchChange,
  ]);
  return (
    <div className={styles.search}>
      <Input
        allowClear
        onChange={e => debouncedOnSearchChange(e.target.value)}
        className={styles.searchInput}
        placeholder={I18n.t('shopify.orders.searchPlaceholder')}
        suffix={<Icon type={'search'} style={{ color: '#ccd6dd' }} />}
      />
    </div>
  );
};

Search.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
};

export default Search;
